import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";

const AirdropModal = ({ show, handleClose }) => {
  const navigate = useNavigate();

  const goToAirdrop = () => {
    handleClose();
    navigate("/airdrop");
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="border-0 p-0 rounded-4 shadow-lg overflow-hidden"
    >
      <div
        style={{
          background:
            "linear-gradient(133deg, #41d3ffa5 0%, #7e42ffa0 47.4%, #dc3fffaf 96.19%)",
          color: "#fff",
          padding: "2rem 1rem",
          textAlign: "center",
          position: "relative",
        }}
      >
       <div
               className=" text-white position-absolute"
               style={{ right: "1rem", top: "0.6rem",cursor:'pointer' }}
               aria-label="Close"
               onClick={handleClose}
             >
               <RxCross2 size={18} />
             </div>
        <h2 className="fw-bold mb-2">🎉 Congratulations! 🎉</h2>
      </div>

      <Modal.Body className="text-center text-white p-4">
        <p className="fs-6 mb-3">
          You are qualified for the airdrop. Complete the tasks and secure your ANANT coins now!
        </p>

        <Button
          variant="main2"
          className="w-100 mt-2 py-2 fw-semibold text-white border-0"
          style={{
            borderRadius: "12px",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.03)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          onClick={goToAirdrop}
        >
          Go to Airdrop Page
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default AirdropModal;
